import { render, staticRenderFns } from "./RegisterSettingBrand.page.vue?vue&type=template&id=e2adf362&"
import script from "./RegisterSettingBrand.page.vue?vue&type=script&lang=js&"
export * from "./RegisterSettingBrand.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports